import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Y from '../../y18n'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import PrivacyPolicyDialog from './privacy-policy-dialog'
import TermsAndConditionsDialog from './terms-and-conditions-dialog'
import LinearProgress from '@material-ui/core/LinearProgress'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import CountriesDropdown from '../../common/dropdowns/countries-dropdown'
import LanguagesDropdown from '../../common/dropdowns/languages-dropdown'
import CountryCodesDropdown from '../../common/dropdowns/country-codes-dropdown'
import * as accountActions from '../../store/accounts'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class RegisterPage extends Component {
  state = {
    email: '',
    firstName: '',
    lastName: '',
    countryCode: '+46',
    phoneNumber: '',
    address: '',
    zipCode: '',
    city: '',
    country: '',
    language: '',
    terms: false,
    termsOpen: false,
    privacyPolicyOpen: false,
    loading: false
  }

  componentDidMount () {
    this.setState({
      country: this.props.locales.country,
      language: this.props.locales.language
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ loading: true })
    this.props.accountActions.register(this.state).then(res => {
      if (!this.props.accounts.registerError && !this.props.loading) {
        this.props.history.push('/registered')
      } else {
        this.setState({ loading: false })
      }
    })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleOpen = name => event => {
    this.setState({
      [name]: true
    })
  }

  handleClose = name => {
    this.setState({
      [name]: false
    })
  }

  handleToggle = name => event => {
    this.setState({ [name]: event.target.checked })
  }

  render () {
    const { classes, locales, accounts } = this.props
    if (!locales.country || !locales.language) return null
    return (
      <TopNavigationAppShell
        content={
          <div className={classes.accountContainer}>
            <Link to='/'>
              <img src={locales.logo} alt='logo' className={classes.logo} />
            </Link>
            <TermsAndConditionsDialog open={this.state.termsOpen} onClose={this.handleClose} />
            <PrivacyPolicyDialog open={this.state.privacyPolicyOpen} onClose={this.handleClose} />
            <Paper elevation={3} square style={{ marginTop: '40px', marginBottom: '20px' }}>
              {accounts.loading && <LinearProgress />}
              <div className={classes.content}>
                <div className={classes.textRow}>
                  <Typography variant='title'>{Y`Register account`}</Typography>
                  <Typography variant='body2' className={classes.spacer}>
                    {Y`You will receive an email with a link where you can set your password`}
                  </Typography>
                </div>
                <form onSubmit={e => this.handleSubmit(e)}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Email`}
                    id='email'
                    value={this.state.email}
                    onChange={this.handleChange('email')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    required
                    fullWidth
                  />
                  <div className={classes.flexRow}>
                    <TextField
                      className={classes.flexItemLeft}
                      label={Y`First name`}
                      id='firstName'
                      value={this.state.firstName}
                      onChange={this.handleChange('firstName')}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.root,
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.formLabel
                      }}
                      required
                    />
                    <TextField
                      className={classes.flexItemRight}
                      label={Y`Last name`}
                      id='lastName'
                      value={this.state.lastName}
                      onChange={this.handleChange('lastName')}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.root,
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.formLabel
                      }}
                      required
                    />
                  </div>
                  <div className={classes.flexRow}>
                    <div className={classes.flexItemLeftSmall}>
                      <CountryCodesDropdown
                        handleChange={this.handleChange('countryCode')}
                        value={this.state.countryCode || ''}
                      />
                    </div>
                    <TextField
                      className={classes.flexItemRight}
                      label={Y`Phone number`}
                      id='phoneNumber'
                      value={this.state.phoneNumber}
                      onChange={this.handleChange('phoneNumber')}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.root,
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.formLabel
                      }}
                      required
                    />
                  </div>
                  <TextField
                    className={classes.spacer}
                    label={Y`Address`}
                    id='address'
                    value={this.state.address}
                    onChange={this.handleChange('address')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    required
                    fullWidth
                  />
                  <div className={classes.flexRow}>
                    <TextField
                      className={classes.flexItemLeft}
                      label={Y`Zip code`}
                      id='zipCode'
                      value={this.state.zipCode}
                      onChange={this.handleChange('zipCode')}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.root,
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.formLabel
                      }}
                      required
                    />
                    <TextField
                      className={classes.flexItemRight}
                      label={Y`City`}
                      id='city'
                      value={this.state.city}
                      onChange={this.handleChange('city')}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.root,
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.formLabel
                      }}
                      required
                    />
                  </div>
                  <div className={classes.flexRow}>
                    <div className={classes.flexItemLeft}>
                      <CountriesDropdown handleChange={this.handleChange('country')} value={this.state.country || ''} />
                    </div>
                    <div className={classes.flexItemRight}>
                      <LanguagesDropdown
                        handleChange={this.handleChange('language')}
                        value={this.state.language || ''}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '20px' }}>
                    <Checkbox
                      checked={this.state.terms}
                      required
                      onChange={this.handleToggle('terms')}
                      value='terms'
                      color='primary'
                    />
                    <Typography variant='body1' style={{ display: 'inline' }}>
                      {Y`I accept`}
                      {' '}
                      <span className={classes.themeLink} onClick={this.handleOpen('termsOpen')}>
                        {Y`the terms and conditions`}
                      </span>
                      {' '}
                      {Y`and`}
                      {' '}
                      <span className={classes.themeLink} onClick={this.handleOpen('privacyPolicyOpen')}>
                        {Y`the privacy policy`}
                      </span>
                    </Typography>
                  </div>
                  {accounts.registerError &&
                    <div className={classes.textRow}>
                      <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                        {Y`${accounts.registerError}`}
                      </Typography>
                    </div>}
                  <div className={classes.buttonRow}>
                    {this.state.terms
                      ? <Button
                        variant='raised'
                        color='primary'
                        style={{ color: '#fff' }}
                        type='submit'
                        >{Y`Register account`}</Button>
                      : <Button
                        variant='raised'
                        color='primary'
                        disabled
                        style={{ color: '#fff' }}
                        type='submit'
                        >{Y`Register account`}</Button>}
                  </div>
                </form>
              </div>
            </Paper>
            <div className={classes.textRow}>
              <Typography variant='body1' className={classes.spacer}>
                {Y`Do you already have an account? Log in`}
                {' '}
                <Link to='/login' className={classes.themeLink}>{Y`here`}</Link>
              </Typography>
            </div>
          </div>
        }
        pageName={'Register'}
      />
    )
  }
}

RegisterPage = connect(mapStateToProps, mapDispatchToProps)(RegisterPage)
export default withStyles(Styles)(RegisterPage)



// WEBPACK FOOTER //
// ./src/pages/account/register.js